import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'
import { useApis } from '../../api/useApiClient';
import { useNotification } from '../../context/NotificationContext';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

import Form from '../Common/Form';
import LoadingDetailsView from '../Common/Skeletons/LoadingDetailsView';

const CustomerForm = ({ editMode = false }) => {

    const { tenantApi } = useApis();
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    // Load customer data if in edit mode
    const { id } = useParams(); // Get the customer ID from the URL parameters if provided (in edit mode)
    const loadformData = async () => {
        setLoading(true);
        try {
            const res = await tenantApi(`/tenants/customers/${id}`);
            const customerData = res.data;
            // Set this explicitly to send only the allowed fields to update. Otherwise API will reject with validation error
            setFormData({
                name: customerData.name || '',
                phoneNumber: customerData.phoneNumber || '',
                email: customerData.email || '',
                address: customerData.address || '',
                additionalInfo: customerData.additionalInfo || '',
            });
        } catch (error) {
            console.error("Error loading customer data", error);
            showNotification(error.message || "Failed to load customer details", 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (editMode) {
            loadformData();
        }
    }, [editMode]);

    // --- end of loading customer data for editing



    // --- Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // Show skeliton while loading initial data (if in edit mode)
    if (loading)
        return <LoadingDetailsView />


    return (
        <Box sx={{ padding: { xs: 2, sm: 3 }, maxWidth: '800px' }}>
            <Form
                resourceName='Customer'
                apiPath='/tenants/customers'
                formData={formData}
                editMode={editMode}
                onSubmit={() => {
                    navigate(-1);
                }}
                onCancel={() => {
                    navigate(-1);
                }}
            >
                <Stack spacing={3}>
                    {/* Name Group */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            fullWidth
                        />
                        <TextField
                            label="Phone number"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Stack>

                    {/* Contact Details Group */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Email address"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            type="email"
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            fullWidth
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Additional Info"
                            name="additionalInfo"
                            value={formData.additionalInfo}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            fullWidth
                        />
                    </Stack>
                </Stack>
            </Form>
        </Box >
    );
};

export default CustomerForm;